export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NoDataMessage.vue?vue&type=template&id=710039fe&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/NoDataMessage.vue?vue&type=template&id=710039fe&scoped=true&
// module id = 1600
// module chunks = 0